import CreatableSelect from 'react-select/creatable'
import { multiselectCustomStyles, MultiselectSelectContainer } from './CreatableMultiselect.style'
import React, { FC, useEffect, useState } from 'react'

interface Option {
  readonly label: string
  readonly value: string
}

const createOption = (label: string) => ({
  label,
  value: label.toLowerCase().replace(/\W/g, ''),
})

type MultiselectProps = {
  values: string[]
  disabled?: boolean
  options: string[]
  onChange: (values: string[]) => void
}

export const CreatableMultiselect: FC<MultiselectProps> = ({ values, options: initOptions, disabled, onChange }) => {
  const [value, setValue] = useState<Option[]>((values || []).map(createOption))

  const options = (initOptions || []).map(createOption)

  const handleCreate = inputValue => {
    const nextValue = inputValue.trim()

    if (!nextValue) return

    createOption(nextValue)

    const newOption = createOption(inputValue)
    setValue(prev => [...prev, newOption])

    onChange([...(values || []).map((label) => label), nextValue])
  }

  const handleChange = newValue => {
    setValue(newValue)
    onChange(newValue.map(({ label }) => label))
  }

  useEffect(() => {
    setValue((values || []).map(createOption))
  }, [values])

  return (
    <MultiselectSelectContainer>
      <CreatableSelect
        isClearable
        isMulti
        isDisabled={disabled}
        styles={multiselectCustomStyles}
        options={options}
        value={value}
        onCreateOption={handleCreate}
        onChange={handleChange}
      />
    </MultiselectSelectContainer>
  )
}
